module.exports = __webpack_public_path__ + "img/oilfox-lg.7f076fed.svg";